'use client';

import { useEffect } from 'react';

import { captureException } from '@/lib/analytics';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    // WEB-326: forward client errors to New Relic when the browser agent
    // is loaded. Optional chaining degrades gracefully to a no-op when the
    // agent is disabled (NEW_RELIC_BROWSER_ENABLED=false) or not yet
    // initialized. `window` is always defined here — error.tsx is a client
    // component and this runs in an effect.
    window.newrelic?.noticeError(error);
    // Also forward to PostHog error tracking. A boundary-caught render error
    // never reaches the SDK's unhandled-exception autocapture, so without this
    // the most user-visible crashes would stay invisible to error tracking.
    // No-op until analytics consent is granted (PostHog isn't initialized).
    captureException(error, { boundary: 'app/error' });
  }, [error]);

  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <h2 className="text-4xl font-bold mb-4">This page didn&apos;t load</h2>
      <p className="text-muted-foreground mb-8">
        Something on this page didn&apos;t load. Try again.
      </p>
      <button
        onClick={() => reset()}
        className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
      >
        Try again
      </button>
    </div>
  );
}
